// Tiny logger that suppresses console in production builds.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const logWarn = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
